import { render, staticRenderFns } from "./TopicTagDetail.vue?vue&type=template&id=3aec895f&scoped=true&"
import script from "./TopicTagDetail.vue?vue&type=script&lang=js&"
export * from "./TopicTagDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopicTagDetail.vue?vue&type=style&index=0&id=3aec895f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec895f",
  null
  
)

export default component.exports